import {getSafely} from 'shared/web';

import {useApiEnums} from '../../../../../hooks/useApiEnums';
import {ApiEnum} from '../../../../../types/ApiEnum';
import {PropertyName} from '../../../../../utils/getEnumByProperty';
import {FiltersType} from '../../../types/FiltersType';
import {UpdateFiltersFunction, useFilters} from '../../FiltersContext/FiltersContext';

type StringArrayKeys<T> = Extract<
  {
    [K in keyof T]: T[K] extends string[] ? K : T[K] extends string[] | undefined ? K : never;
  }[keyof T],
  keyof T
>;

export type StringBasedFilterName = StringArrayKeys<FiltersType>;

export const getStringBasedTags = (
  filterName: StringBasedFilterName,
  apiEnum: ApiEnum,
  filters: FiltersType,
  onUpdateFilters: UpdateFiltersFunction
) => {
  const filterValues = getSafely(filters, filterName);

  return (
    filterValues?.map((value) => ({
      label: apiEnum.find(({key}) => key === value)?.label,
      onDelete: () =>
        onUpdateFilters(
          filterName,
          filterValues?.filter((item) => value !== item)
        ),
    })) ?? []
  );
};

export const useGetStringBasedTags = () => {
  const {filters, onUpdateFilters} = useFilters();
  const {getEnum} = useApiEnums({flat: true});

  return (filterName: StringBasedFilterName, propertyName: PropertyName) =>
    getStringBasedTags(filterName, getEnum(propertyName), filters, onUpdateFilters);
};
